// extracted by mini-css-extract-plugin
export default {"page":"styles-module__page--YZjjT","subnav":"styles-module__subnav--TRUW6"};